// extracted by mini-css-extract-plugin
export var root = "Qrjj";
export var rootExpanded = "gSBp";
export var rootIcon = "Sf1+";
export var rootIconClose = "jlTk";
export var rootInput = "_2hxl";